import _ from 'lodash';
import { clearRetailerDetails } from 'registration/actions/fetch-retailer-details.actions';
import { createAccount } from 'registration/actions/create-account.actions';
import reviewTemplate from './review-dialog.html';
import template from './self-registration.html';
import { checkAccess } from "app/actions/app.actions";

const mapStateToThis = ({ session, registration }) => {
  const { ownerValidationMethod, retailer, created } = registration;

  return {
    session,
    ownerValidationMethod,
    retailer,
    created,
  };
};

const mapDispatchToThis = {
  clearRetailerDetails,
  createAccount,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'Notifications')
class SelfRegistrationController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    if (!this.checkAccess('registration.primary')) {
      this.$state.go('home-view');
    }
    this.clearRegistrationFormRef = this.clearRegistrationForm.bind(this);
    this.clearRegistrationFormWithRetailerRef = this.clearRegistrationFormWithRetailer.bind(this);
    this.registrationFormModel = {
      validationDTO: {},
    };
    this.clearRegistrationFormWithRetailer();
  }

  $onDestroy() {
    this.clearRegistrationFormWithRetailer();
    this.unsubscribe();
  }

  clearRegistrationForm() {
    this.registrationFormModel = {
      validationDTO: {},
    };
  }

  clearRegistrationFormWithRetailer() {
    this.clearRegistrationForm();
    this.clearRetailerDetails();
  }

  onSubmitRegistrationForm($event, $formCtrl) {
    $event.stopPropagation();
    $event.preventDefault();

    const resp = this.evalRegistrationForm($formCtrl);
    return resp;
  }

  evalRegistrationForm($formCtrl) {
    $formCtrl.$setSubmitted();
    $formCtrl.phone.$setTouched();
    $formCtrl.userPasswordConfirm.$validate();
    $formCtrl.confirmEmail.$validate();

    if ($formCtrl.$invalid) {
      return;
    }

    this.showReviewDialog().then(() => this.addAccount());
  }

  async addAccount() {
    await this.createAccount(this.registrationFormModel);
    if (this.created) {
      this.$state.go('registration-confirmation');
    }
  }

  showReviewDialog() {
    const data = _.cloneDeep(this.registrationFormModel);

    return this.Notifications.showComplexDialog({
      template: reviewTemplate,
      bindToController: true,
      resolve: {
        retailer: () => this.retailer,
        data: () => data,
      },
    }).result;
  }
}

export default class SelfRegistrationComponent {
  constructor() {
    this.template = template;
    this.controller = SelfRegistrationController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/self-registration/self-registration-component.js